export default {
  data() {
    return {
      primaryLocale: App.getPrimaryLocale(),
    };
  }
}



// WEBPACK FOOTER //
// ./public/themes/frontend/uikit3/extensions/rubinred/content/assets/js/mixins/PrimaryLocaleAwareComponent.js